import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { LocalStorage, SessionStorage } from 'ngx-webstorage';

import { ConfigService } from '../../shared/utils/config.service';
import { LOGIN_PAGE_URL } from '../../models';
import { AuthTokenModel } from '../../login/models';

@Injectable()
export class AuthenticationService implements OnDestroy {
  private headers: HttpHeaders = new HttpHeaders({
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  baseUrl: string = '';

  @SessionStorage('access_token')
  accessToken: string;
  @SessionStorage('id_token')
  idToken: string;
  @SessionStorage('refresh_token')
  refreshToken: string;
  @SessionStorage('user_roles')
  userRoles: string[];
  @SessionStorage('app_version')
  app_version: string;
  @SessionStorage('app_environment')
  app_environment: string;
  @SessionStorage('sso_user')
  sso_user: boolean;

  bodyListener: EventListener = null;

  get isLoggedIn(): boolean {
    return !!this.idToken;
  }

  constructor(
    private router: Router,
    private configService: ConfigService,
    private http: HttpClient
  ) {
    this.baseUrl = configService.getApiURI();
  }

  ngOnDestroy() { }

  logout(
    returnUrl?: string
  ) {
    this.router.navigate([LOGIN_PAGE_URL], !returnUrl ? {} : { queryParams: { returnUrl } });
  }

  refreshTokens():Observable<AuthTokenModel> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
   
    return this.http
      .post<AuthTokenModel>(this.baseUrl + '/authentication/refreshTokens',
        {
          "RefreshToken": this.refreshToken
        });
  }
}

